import styled from "styled-components";
import colors from "assets/scss/colors.scss";

const StyleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 24px;
  background: #ffffff;
  border-radius: 8px 8px 0px 0px;
  width: 100%;

  .p-inputswitch {
    min-width: 45px;
  }
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
    background: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
    &:hover {
      background: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
    }
  }
  .p-checkbox .p-checkbox-box.p-highlight {
    background: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
    border: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
    &:hover {
      background: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
      border: ${props => props.businessColor ? props.businessColor : '#6B47F5'};
    }
  }
  .items-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 0px 0px 12px 12px;
    width: 100%;
    .feature-items {
      display: flex;
      margin: 20px 0;
      flex-direction: column;
      align-items: flex-start;
      padding: 24px;
      background: #f2f3f5;
      border-radius: 12px;
      width: 100%;

      .feature-item {
        box-sizing: border-box;
        display: flex;
        margin: 5px 0;
        flex-direction: column;
        align-items: flex-start;
        padding: 14px 16px;
        border: 1.5px solid #d9dce1;
        border-radius: 4px;
        width: 100%;
        .p-radiobutton-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0px;
          background: #d9dce1;
          border-radius: 100px;
        }
        .p-radiobutton .p-radiobutton-box.p-highlight{
          border-color: ${props => `${props.businessColor} !important`};
          background: ${props => `${props.businessColor} !important`};
        }
        .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
          border-color: ${props => props.businessColor};
        }
        .p-checkbox .p-checkbox-box.p-highlight {
          background: ${props => props.businessColor} !important;
        }
        .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover{
          border-color: ${props => props.businessColor};
        }
      }
    }
  }
  @media only screen and (max-width: 786px) {
    background: Transparent;
    padding: 0;
    .items-section {
      padding: 0.75rem;
      .feature-items {
        padding: 0.5rem 0.75rem;
        * {
          font-size: 1rem;
        }
      }
    }
  }
`;

export default StyleWrapper;
